export const MAX_PRICE_PRECISION = 20;
export function decimalPlaces(value) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) return 0;
    // Remove binary floating point noise when a provider sent numeric JSON.
    const text = typeof value === 'number' ? Number(value.toPrecision(14)).toString() : String(value).trim();
    const [coefficient, exponent = '0'] = text.toLowerCase().split('e');
    const fraction = (coefficient.split('.')[1] || '').replace(/0+$/, '');
    return Math.min(MAX_PRICE_PRECISION, Math.max(0, fraction.length - Number(exponent)));
}
export function symbolPricePrecision(info = {}) {
    const priceFilter = (info.filters || []).find(filter => filter.filterType === 'PRICE_FILTER');
    const scale = Number(info.pricescale || info.priceScale);
    const tick = priceFilter?.tickSize ?? info.tickSize ?? info.tick_size ?? info.minTick ?? info.min_tick ?? info.TICK_SIZE ?? info.SEM_TICK_SIZE ?? (scale > 0 ? Number(info.minmov || 1) / scale : undefined);
    if (Number(tick) > 0) return decimalPlaces(tick);
    for (const key of ['pricePrecision', 'price_precision', 'precision', 'decimalPlaces', 'decimals', 'digits', 'price_decimals']) {
        const value = info[key];
        if (value != null && value !== '' && Number.isInteger(Number(value)) && Number(value) >= 0) return Math.min(MAX_PRICE_PRECISION, Number(value));
    }
    return null;
}
export function inferredPricePrecision(rows = [], columns = [1,2,3,4]) {
    let precision = 0;
    for (const row of rows.slice(-500)) for (const column of columns) {
        if (row[column] != null && Number.isFinite(Number(row[column]))) precision = Math.max(precision, decimalPlaces(row[column]));
    }
    return precision;
}
export function resolvePricePrecision(info = {}, rows = [], override = null) {
    const metadata = symbolPricePrecision(info);
    // Exchange metadata avoids both rounding drift and scanning candle history
    // on every live price update. Infer only for providers without metadata.
    let required = metadata ?? inferredPricePrecision(rows);
    if (metadata == null && required < 2) required = 2;
    const manual = override != null && override !== '' && override !== 'auto' ? Number(override) : NaN;
    return Math.min(MAX_PRICE_PRECISION, Math.max(required, Number.isInteger(manual) && manual >= 0 ? manual : 0));
}
